// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as TC from "common/src/components/TC.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Data9 from "common/src/data/Data9.bs.js";
import * as PlApi from "../player/PlApi.bs.js";
import * as Route from "../Route.bs.js";
import * as Unit9 from "common/src/data/Unit9.bs.js";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";
import * as Global from "common/src/Global.bs.js";
import * as LlIcon from "../components/LlIcon.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Trait9 from "common/src/data/Trait9.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as PlRadar from "../player/PlRadar.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as $$Promise from "common/src/Promise.bs.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as WrapUnitImg from "../set-wrapped/WrapUnitImg.bs.js";
import * as Router from "next/router";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as PlRadarChart from "../player/PlRadarChart.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as UseCountUp from "use-count-up";
import * as PlRadarChart2 from "../player/PlRadarChart2.bs.js";
import * as WrappedLayout from "../set-wrapped/WrappedLayout.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as WrappedSection from "../set-wrapped/WrappedSection.bs.js";
import * as PlExpandedMatch from "../player2/PlExpandedMatch.bs.js";
import * as WrappedAugments from "../set-wrapped/WrappedAugments.bs.js";
import * as WrappedPlaystyle from "../set-wrapped/WrappedPlaystyle.bs.js";
import * as WrappedTimeStats from "../set-wrapped/WrappedTimeStats.bs.js";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";
import * as WrappedPatchStats from "../set-wrapped/WrappedPatchStats.bs.js";
import * as WrappedRivalStats from "../set-wrapped/WrappedRivalStats.bs.js";
import * as WrappedChaseTraits from "../set-wrapped/WrappedChaseTraits.bs.js";
import * as WrappedShareButton from "../set-wrapped/WrappedShareButton.bs.js";
import * as WrappedUnitBubbles from "../set-wrapped/WrappedUnitBubbles.bs.js";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import * as WrappedMatchSummary from "../set-wrapped/WrappedMatchSummary.bs.js";
import Button from "@mui/material/Button";
import * as PlPlacesDistribution from "../player2/PlPlacesDistribution.bs.js";
import * as WrappedSectionHeader from "../set-wrapped/WrappedSectionHeader.bs.js";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";
import * as WrappedCompanionStats from "../set-wrapped/WrappedCompanionStats.bs.js";
import * as WrappedScreenshotButton from "../set-wrapped/WrappedScreenshotButton.bs.js";
import * as PlayerRadarModalContents from "../player/PlayerRadarModalContents.bs.js";
import * as WrappedRivalCompanionStats from "../set-wrapped/WrappedRivalCompanionStats.bs.js";

function SetWrapped9Page$UnitStats(Props) {
  var games = Props.games;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "text-sm pt-2"
                }, String(games) + " games"));
}

var UnitStats = {
  make: SetWrapped9Page$UnitStats
};

function SetWrapped9Page$CountUp(Props) {
  var end = Props.end;
  return React.createElement(UseCountUp.CountUp, {
              easing: "linear",
              isCounting: true,
              end: end,
              duration: 1.5 + Math.sqrt(Math.sqrt(Global.f(end))) / 10
            });
}

var CountUp = {
  make: SetWrapped9Page$CountUp
};

var patches = [
  13060,
  13061,
  13070,
  13071,
  13080,
  13090,
  13091,
  13100,
  13110
];

var allChaseTraits = [
  [
    "Set9_Bastion",
    4
  ],
  [
    "Set9_Challenger",
    4
  ],
  [
    "Set9_Deadeye",
    3
  ],
  [
    "Set9_Demacia",
    4
  ],
  [
    "Set9_Freljord",
    3
  ],
  [
    "Set9_Marksman",
    3
  ],
  [
    "Set9_Ionia",
    3
  ],
  [
    "Set9_Preserver",
    3
  ],
  [
    "Set9_Noxus",
    3
  ],
  [
    "Set9_Piltover",
    2
  ],
  [
    "Set9_Shurima",
    4
  ],
  [
    "Set9_Slayer",
    5
  ],
  [
    "Set9_Sorcerer",
    4
  ],
  [
    "Set9_Strategist",
    4
  ],
  [
    "Set9_ShadowIsles",
    3
  ],
  [
    "Set9_Targon",
    3
  ],
  [
    "Set9_Void",
    3
  ],
  [
    "Set9_Zaun",
    3
  ]
];

function SetWrapped9Page$TopComps(Props) {
  var queueId = Props.queueId;
  var topCompositions = Props.topCompositions;
  var set = TftSet.use(undefined);
  return React.createElement("div", {
              className: "pt-16"
            }, React.createElement(WrappedSectionHeader.make, {
                  title: "Favorite Team Compositions"
                }), Belt_Array.mapWithIndex(Belt_Array.slice(topCompositions, 0, 3), (function (idx, param) {
                    var places = param[1];
                    var uids2 = Belt_Array.keep(param[3], (function (uid) {
                            return Belt_Option.isSome(Unit9.fromApiNameSafe(uid));
                          }));
                    var coreTraits = TC.getCoreTraits([[
                            uids2,
                            []
                          ]], set);
                    var renderTraits = Belt_SortArray.stableSortBy(coreTraits, (function (param, param$1) {
                            return Caml.caml_int_compare(Sd.traitRankUnitCount(param$1[0], param$1[1], set), Sd.traitRankUnitCount(param[0], param[1], set));
                          }));
                    var renderTrait = Belt_Option.flatMap(Belt_Array.get(renderTraits, 0), (function (param) {
                            var r = param[1];
                            var t = param[0];
                            if (Sd.traitRankUnitCount(t, r, set) > 3) {
                              return [
                                      t,
                                      r
                                    ];
                            }
                            
                          }));
                    var carries = [];
                    var unitItems = Belt_MutableMapString.make(undefined);
                    var unitItems2 = Belt_MutableMapString.make(undefined);
                    Belt_Array.forEach(Belt_Array.slice(param[2], 0, 11), (function (param) {
                            var uid = param[0];
                            if (!carries.includes(uid)) {
                              carries.push(uid);
                            }
                            var curr = Belt_Option.getWithDefault(Belt_MutableMapString.get(unitItems, uid), []);
                            curr.push(param[1]);
                            Belt_MutableMapString.set(unitItems, uid, curr);
                            var curr$1 = Belt_Option.getWithDefault(Belt_MutableMapString.get(unitItems2, uid), 0);
                            return Belt_MutableMapString.set(unitItems2, uid, curr$1 + param[2] | 0);
                          }));
                    var carriesOrder = Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_MutableMapString.toArray(unitItems2), (function (param) {
                                return Belt_Option.isSome(Unit9.fromApiNameSafe(param[0]));
                              })), (function (param, param$1) {
                            return Caml.caml_int_compare(param$1[1], param[1]);
                          }));
                    var carriesOrder$1 = Belt_Option.isNone(Belt_Array.get(carriesOrder, 1)) || Belt_Array.getExn(carriesOrder, 1)[1] > (Belt_Array.getExn(carriesOrder, 0)[1] / 2 | 0) ? Belt_Array.map(Belt_Array.slice(carriesOrder, 0, 2), (function (prim) {
                              return prim[0];
                            })) : Belt_Array.map(Belt_Array.slice(carriesOrder, 0, 1), (function (prim) {
                              return prim[0];
                            }));
                    var title = Belt_Option.mapWithDefault(renderTrait, "", (function (param) {
                            return Trait9.toName(Trait9.fromApiName(param[0])) + " ";
                          })) + Unit9.toName(Unit9.fromApiName(Belt_Array.getExn(carriesOrder$1, 0))) + Belt_Option.mapWithDefault(Belt_Array.get(carriesOrder$1, 1), "", (function (u) {
                            return " & " + Unit9.toName(Unit9.fromApiName(u));
                          }));
                    var totPlace = queueId === 1150 ? Belt_Array.reduce(places, 0, (function (a, v) {
                              return a + Global.f((v + 1 | 0) / 2 | 0) * 2 - 0.5;
                            })) : Global.f(Belt_Array.reduce(places, 0, (function (a, v) {
                                  return a + v | 0;
                                })));
                    var match = Belt_Array.get(renderTraits, 0);
                    var tmp;
                    var exit = 0;
                    var traitId;
                    if (renderTrait !== undefined) {
                      traitId = renderTrait[0];
                      exit = 1;
                    } else if (match !== undefined) {
                      traitId = match[0];
                      exit = 1;
                    } else {
                      tmp = null;
                    }
                    if (exit === 1) {
                      tmp = React.createElement(TraitImage.PlainIcon.make, {
                            traitId: traitId,
                            size: 24
                          });
                    }
                    return React.createElement("div", {
                                key: String(idx),
                                className: "flex" + (
                                  idx === 2 ? " pb-2" : " pb-8"
                                )
                              }, React.createElement("div", undefined, React.createElement("div", {
                                        className: "flex items-center pb-2"
                                      }, tmp, React.createElement("div", {
                                            className: "text-xl font-medium pl-[6px]"
                                          }, title)), React.createElement("div", {
                                        className: "flex"
                                      }, Belt_Array.map(Belt_SortArray.stableSortBy(uids2, (function (uid1, uid2) {
                                                  return Caml.caml_int_compare(Sd.unitTier(uid1), Sd.unitTier(uid2));
                                                })), (function (unitId) {
                                              return React.createElement("div", {
                                                          key: unitId,
                                                          className: "pr-2"
                                                        }, React.createElement(UnitImageExtended.make, {
                                                              size: 52,
                                                              unitId: unitId,
                                                              items: Belt_Array.map(Belt_Array.slice(Belt_Option.getWithDefault(Belt_MutableMapString.get(unitItems, unitId), []), 0, 3), Data.encodeItemId)
                                                            }));
                                            })))), React.createElement("div", {
                                    className: "pl-4 mb-[-2px] mt-auto"
                                  }, React.createElement("div", {
                                        className: CssJs.style([
                                              CssJs.marginTop(CssJs.auto),
                                              CssJs.lineHeight({
                                                    NAME: "abs",
                                                    VAL: 1
                                                  }),
                                              CssJs.display(CssJs.grid),
                                              CssJs.gridTemplateColumns([
                                                    CssJs.auto,
                                                    CssJs.auto
                                                  ]),
                                              CssJs.alignItems(CssJs.flexEnd),
                                              CssJs.gridGap(CssJs.px(6)),
                                              CssJs.gridRowGap(CssJs.px(8))
                                            ])
                                      }, React.createElement("div", {
                                            className: "wrapped-num text-lg text-primary-11 leading-none ml-auto"
                                          }, String(places.length)), React.createElement("div", {
                                            className: ""
                                          }, "Games"), React.createElement("div", {
                                            className: "wrapped-num text-lg text-primary-11 leading-none text-right"
                                          }, Global.toFixed(undefined, totPlace / Global.f(places.length))), React.createElement("div", {
                                            className: ""
                                          }, "Place"), React.createElement("div", {
                                            className: "wrapped-num text-lg text-primary-11 leading-none text-right"
                                          }, Global.formatPct(0, Global.f(Belt_Array.keep(places, (function (p) {
                                                          return p <= 4;
                                                        })).length) / Global.f(places.length)) + "%"), React.createElement("div", undefined, "Top 4"))));
                  })));
}

var TopComps = {
  make: SetWrapped9Page$TopComps
};

function SetWrapped9Page$HighlightMatches(Props) {
  var data = Props.data;
  var setExpandedMatchId = Props.setExpandedMatchId;
  var set = TftSet.use(undefined);
  var heroParticipant = data.topMatchItems;
  var totItems = Belt_Array.concatMany(Belt_Array.map(heroParticipant.info.units, (function (u) {
              return Belt_Array.keep(u.items, (function (i) {
                            return i > 10;
                          }));
            }))).length;
  var heroParticipant$1 = data.topMatchEmblems;
  var allSpats = Belt_Array.concat(Data9.craftableSpats, Data9.elusiveSpats);
  var totEmblems = Belt_Array.concatMany(Belt_Array.map(heroParticipant$1.info.units, (function (u) {
              return Belt_Array.keep(u.items2, (function (i) {
                            return allSpats.includes(i);
                          }));
            }))).length;
  var heroParticipant$2 = data.topMatchYour3s;
  var tot3stars = Belt_Array.keep(heroParticipant$2.info.units, (function (u) {
          return u.tier === 3;
        })).length;
  var heroParticipant$3 = data.topMatchPlayerDamage;
  var heroParticipant$4 = data.topMatchClose8;
  var heroParticipant$5 = data.topMatchArmyCost;
  var totCost = PlUtils.calcBoardValue(heroParticipant$5.info.units, set);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "pt-16"
                }, React.createElement(WrappedSectionHeader.make, {
                      title: "Did you know?"
                    })), React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: "text-lg font-medium pb-1"
                    }, "You have had ", React.createElement("span", {
                          className: "wrapped-num text-primary-11"
                        }, String(totItems)), " items in one game..."), React.createElement("div", {
                      className: "pt-1 pb-6"
                    }, React.createElement(WrappedMatchSummary.make, {
                          firstMatch: true,
                          heroParticipant: heroParticipant,
                          onShowDetails: (function (mid) {
                              return Curry._1(setExpandedMatchId, (function (param) {
                                            return mid;
                                          }));
                            })
                        }))), React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: "text-lg font-medium pb-1"
                    }, "You have had ", React.createElement("span", {
                          className: "wrapped-num text-primary-11"
                        }, String(totEmblems)), " emblems in one game..."), React.createElement("div", {
                      className: "pt-1 pb-6"
                    }, React.createElement(WrappedMatchSummary.make, {
                          firstMatch: true,
                          heroParticipant: heroParticipant$1,
                          onShowDetails: (function (mid) {
                              return Curry._1(setExpandedMatchId, (function (param) {
                                            return mid;
                                          }));
                            })
                        }))), React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: "text-lg font-medium pb-1"
                    }, "You have struck gold by 3-starring ", React.createElement("span", {
                          className: "wrapped-num text-primary-11"
                        }, String(tot3stars)), " units in a single game!"), React.createElement("div", {
                      className: "pt-1 pb-6"
                    }, React.createElement(WrappedMatchSummary.make, {
                          firstMatch: true,
                          heroParticipant: heroParticipant$2,
                          onShowDetails: (function (mid) {
                              return Curry._1(setExpandedMatchId, (function (param) {
                                            return mid;
                                          }));
                            })
                        }))), React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: "text-lg font-medium pb-1"
                    }, "You have dominated this match by dealing a total of ", React.createElement("span", {
                          className: "wrapped-num text-primary-11"
                        }, String(heroParticipant$3.info.totalDamageToPlayers)), " player damage!"), React.createElement("div", {
                      className: "pt-1 pb-6"
                    }, React.createElement(WrappedMatchSummary.make, {
                          firstMatch: true,
                          heroParticipant: heroParticipant$3,
                          onShowDetails: (function (mid) {
                              return Curry._1(setExpandedMatchId, (function (param) {
                                            return mid;
                                          }));
                            })
                        }))), React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: "text-lg font-medium pb-1"
                    }, "This was your closest match! What a nail biter... Check the lobby!"), React.createElement("div", {
                      className: "pt-1 pb-6"
                    }, React.createElement(WrappedMatchSummary.make, {
                          firstMatch: true,
                          heroParticipant: heroParticipant$4,
                          onShowDetails: (function (mid) {
                              return Curry._1(setExpandedMatchId, (function (param) {
                                            return mid;
                                          }));
                            })
                        }))), React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: "text-lg font-medium pb-1"
                    }, "Finally, this match was your strongest army, costing a total of ", React.createElement("span", {
                          className: "wrapped-num text-primary-11"
                        }, String(totCost)), " gold!"), React.createElement("div", {
                      className: "pt-1 pb-6"
                    }, React.createElement(WrappedMatchSummary.make, {
                          firstMatch: true,
                          heroParticipant: heroParticipant$5,
                          onShowDetails: (function (mid) {
                              return Curry._1(setExpandedMatchId, (function (param) {
                                            return mid;
                                          }));
                            })
                        }))));
}

var HighlightMatches = {
  make: SetWrapped9Page$HighlightMatches
};

function SetWrapped9Page$Stat(Props) {
  var label = Props.label;
  var v = Props.v;
  var count = v[0];
  return React.createElement("div", undefined, React.createElement("div", undefined, label), React.createElement("div", undefined, String(count)), React.createElement("div", undefined, Global.toFixed(undefined, Global.f(v[1]) / Global.f(count))), React.createElement("div", undefined, Global.formatPct2(undefined, Global.f(v[2]) / Global.f(count))), React.createElement("div", undefined, Global.formatPct2(undefined, Global.f(v[3]) / Global.f(count))));
}

var Stat = {
  make: SetWrapped9Page$Stat
};

function SetWrapped9Page$WrappedRadar(Props) {
  var data = Props.data;
  var metaRating = data.metaRating;
  var itemsRating = data.itemsRating;
  var executionRating = data.executionRating;
  var econRating = data.econRating;
  var augmentsRating = data.augmentsRating;
  var compositionsRating = PlRadar.handleDelta((metaRating + 0.33) / 0.5);
  var econRating$1 = PlRadar.handleDelta((econRating + 0.33) / 0.5);
  var executionRating$1 = PlRadar.handleDelta((executionRating + 0.33) / 0.5);
  var itemsRating$1 = PlRadar.handleDelta((itemsRating + 0.33) / 0.5);
  var augmentsRating$1 = PlRadar.handleDelta((augmentsRating + 0.33) / 0.5);
  var scoutingRating = PlRadar.handleDelta(data.flexRating);
  return React.createElement(PlRadarChart2.make, {
              compositionsRating: compositionsRating,
              econRating: econRating$1,
              scoutingRating: scoutingRating,
              executionRating: executionRating$1,
              itemsRating: itemsRating$1,
              augmentsRating: augmentsRating$1,
              small: false
            });
}

var WrappedRadar = {
  make: SetWrapped9Page$WrappedRadar
};

function SetWrapped9Page$RankedStats(Props) {
  var region = Props.region;
  var data = Props.data;
  var queueId = Props.queueId;
  var match = React.useState(function () {
        return false;
      });
  var setShowPlayerRadarInfo = match[1];
  var showPlayerRadarInfo = match[0];
  var set = TftSet.use(undefined);
  var tmp;
  if ([
        1100,
        1130,
        1160
      ].includes(queueId) && Belt_Option.isSome(data.peakRank)) {
    var localRank = data.localRank;
    var tmp$1;
    if (localRank !== undefined) {
      var rank = localRank[0] === 0 ? 1 : localRank[0];
      var rendered = rank <= 1000 ? String(rank + 1 | 0) : Global.formatPct(undefined, localRank[1]) + "%";
      tmp$1 = React.createElement("div", {
            className: "wrapped-num"
          }, React.createElement("span", undefined, "Top ", React.createElement("span", undefined, rendered)), " " + Region.toName3(region));
    } else {
      tmp$1 = null;
    }
    var match$1 = Belt_Array.get(Belt_Array.keep(data.topLpUnits, (function (param) {
                return Belt_Option.isSome(Unit9.fromApiNameSafe(param[0]));
              })), 0);
    var tmp$2;
    if (match$1 !== undefined) {
      var unitId = match$1[0];
      tmp$2 = React.createElement("div", {
            className: "flex items-center pt-3"
          }, React.createElement("div", {
                className: "flex-shrink-0"
              }, React.createElement(UnitImage.make, {
                    unitId: unitId,
                    size: 50
                  })), React.createElement("div", {
                className: "pl-3"
              }, React.createElement("div", {
                    className: "text-sm italic"
                  }, "Backbone of your climb"), React.createElement("div", {
                    className: "leading-tight"
                  }, Unit9.toName(Unit9.fromApiName(unitId)), React.createElement("span", {
                        className: "wrapped-num text-primary-11"
                      }, " +" + String(match$1[1]) + "LP"))));
    } else {
      tmp$2 = null;
    }
    var match$2 = Belt_Array.get(data.topLpTraits, 0);
    var tmp$3;
    if (match$2 !== undefined) {
      var rank$1 = match$2[1];
      var traitId = match$2[0];
      tmp$3 = React.createElement("div", {
            className: "flex items-center pt-3"
          }, React.createElement("div", {
                className: "flex-shrink-0"
              }, React.createElement(TraitImage.PlainIcon.make, {
                    traitId: traitId,
                    rank: rank$1,
                    size: 50
                  })), React.createElement("div", {
                className: "pl-3"
              }, React.createElement("div", {
                    className: "text-sm italic"
                  }, "The Chosen trait"), React.createElement("div", {
                    className: "leading-tight"
                  }, String(Sd.traitRankUnitCount(traitId, rank$1, set)) + " " + Trait9.toName(Trait9.fromApiName(traitId)), React.createElement("span", {
                        className: "wrapped-num text-primary-11"
                      }, React.createElement("span", {
                            className: "wrapped-num"
                          }, " +" + String(match$2[2]) + "LP")))));
    } else {
      tmp$3 = null;
    }
    var match$3 = Belt_Array.get(Belt_Array.keep(data.topLpItems, (function (param) {
                return param[0] !== "EmptyBag";
              })), 0);
    var tmp$4;
    if (match$3 !== undefined) {
      var itemId = match$3[0];
      tmp$4 = React.createElement("div", {
            className: "flex items-center pt-3"
          }, React.createElement("div", {
                className: "flex-shrink-0 rounded overflow-hidden"
              }, React.createElement(ItemImage.make, {
                    itemId: itemId,
                    size: 50,
                    rounded: "rounded"
                  })), React.createElement("div", {
                className: "pl-3"
              }, React.createElement("div", {
                    className: "text-sm italic"
                  }, "Your lucky charm"), React.createElement("div", {
                    className: "leading-tight"
                  }, Dict.getExn(Data9.items, itemId).name, React.createElement("span", {
                        className: "wrapped-num text-primary-11"
                      }, React.createElement("span", {
                            className: "wrapped-num"
                          }, " +" + String(match$3[1]) + "LP")))));
    } else {
      tmp$4 = null;
    }
    var match$4 = data.winningFormula;
    var match$5 = Belt_Array.get(data.botLpAugments, 0);
    var tmp$5;
    if (match$5 !== undefined) {
      var augId = match$5[0];
      var info = Data.augmentInfoExn(augId, set);
      tmp$5 = React.createElement("div", {
            className: "flex items-center pt-6"
          }, React.createElement("div", {
                className: "flex-shrink-0"
              }, React.createElement(AugmentImage.make, {
                    augId: Data.encodeAugmentId(augId),
                    size: 50
                  })), React.createElement("div", {
                className: "pl-3"
              }, React.createElement("div", {
                    className: "text-sm italic"
                  }, "Probably a missclick"), React.createElement("div", {
                    className: "leading-tight"
                  }, info.name, React.createElement("span", {
                        className: "wrapped-num text-primary-11"
                      }, React.createElement("span", {
                            className: "wrapped-num"
                          }, " " + String(match$5[1]) + "LP")))));
    } else {
      tmp$5 = null;
    }
    tmp = React.createElement("div", {
          className: "pt-16"
        }, React.createElement("div", {
              className: "flex justify-between items-center pb-4"
            }, React.createElement("h4", {
                  className: "font-medium text-2xl text-secondary-11 font-montserrat font-semibold"
                }, "How did you do?"), React.createElement(Button, {
                  onClick: (function (param) {
                      return Curry._1(setShowPlayerRadarInfo, (function (param) {
                                    return true;
                                  }));
                    }),
                  variant: "outlined",
                  color: "primary",
                  size: "small",
                  children: "What are these grades?"
                })), React.createElement("div", {
              className: "flex justify-between"
            }, React.createElement("div", {
                  className: "flex flex-col items-start text-lg"
                }, React.createElement("div", {
                      className: "flex items-center"
                    }, React.createElement("div", {
                          className: "m-[-10px] ml-[-14px]"
                        }, queueId === 1130 ? React.createElement("div", {
                                className: "p-2 pr-4"
                              }, React.createElement("img", {
                                    height: "70",
                                    src: "https://ap.tft.tools/img/banner/badge_" + Belt_Array.getExn(data.peakRank[0].split(" "), 0).toLowerCase() + ".png?w=70",
                                    width: "70"
                                  })) : React.createElement("img", {
                                height: "106",
                                src: "https://ap.tft.tools/img/banner/tft_regalia_" + Belt_Array.getExn(data.peakRank[0].split(" "), 0).toLowerCase() + ".tftm.png?w=106",
                                width: "106"
                              })), React.createElement("div", {
                          className: "leading-normal pl-2"
                        }, React.createElement("div", undefined, React.createElement("span", {
                                  className: "wrapped-num pr-1"
                                }, LpChartUtils.renderDivisionName(data.finalRank[0]) + " ", React.createElement("span", {
                                      className: "wrapped-num"
                                    }, String(data.finalRank[1])), " LP")), tmp$1, React.createElement("div", {
                              className: "wrapped-num pt-0"
                            }, React.createElement("span", {
                                  className: "pr-1"
                                }, LpChartUtils.renderDivisionName(data.peakRank[0]) + " ", React.createElement("span", undefined, String(data.peakRank[1])), " LP"), "Peak"))), React.createElement("div", {
                      className: "pt-4"
                    }, React.createElement("div", {
                          className: "pb-1"
                        }, React.createElement("span", {
                              className: "wrapped-num text-primary-11"
                            }, String(data.hotStreak)), " top 4 hot streak"), React.createElement("div", {
                          className: "pb-1"
                        }, React.createElement("span", {
                              className: "wrapped-num text-primary-11"
                            }, String(data.coldStreak)), " bottom 4 cold streak"), React.createElement("div", {
                          className: "pb-1"
                        }, "You have won LP in ", React.createElement("span", {
                              className: "wrapped-num text-primary-11"
                            }, String(data.daysLpWon[0]) + "/" + String(data.daysLpWon[1])), " (" + Global.toFixed(0, Global.f(data.daysLpWon[0]) * 100 / Global.f(data.daysLpWon[1])) + "%) days"), tmp$2, tmp$3, tmp$4, match$4 !== undefined ? React.createElement("div", {
                            className: "flex items-center pt-3"
                          }, React.createElement("div", {
                                className: "flex-shrink-0"
                              }, React.createElement(UnitImageExtended.make, {
                                    size: 50,
                                    unitId: match$4[0],
                                    itemSize: 26,
                                    itemSizeCompact: 26,
                                    items: [match$4[1]]
                                  })), React.createElement("div", {
                                className: "pl-3"
                              }, React.createElement("div", {
                                    className: "text-sm italic"
                                  }, "Your winning formula"), React.createElement("div", {
                                    className: "leading-tight"
                                  }, React.createElement("span", {
                                        className: "wrapped-num text-primary-11"
                                      }, React.createElement("span", {
                                            className: "wrapped-num"
                                          }, String(match$4[2]))), " games won"))) : null, tmp$5)), React.createElement("div", {
                  className: "flex flex-col items-end justify-evenly"
                }, React.createElement(SetWrapped9Page$WrappedRadar, {
                      data: data
                    }), React.createElement("div", {
                      className: "pt-6 pr-3"
                    }, React.createElement(PlPlacesDistribution.Inner.make, {
                          places: Belt_Array.concatMany(Belt_Array.mapWithIndex(data.placeDistribution, (function (idx, c) {
                                      return Belt_Array.make(c, idx + 1 | 0);
                                    }))),
                          chartHeight: 144,
                          barArea: 21,
                          doubleUp: false
                        })))));
  } else {
    var metaRating = data.metaRating;
    var itemsRating = data.itemsRating;
    var executionRating = data.executionRating;
    var compositionsRating = PlRadar.handleDelta((metaRating + 0.4) / 0.6);
    var econRating = PlRadar.handleDelta((data.econRating + 0.4) / 0.6);
    var executionRating$1 = PlRadar.handleDelta((executionRating + 0.4) / 0.6);
    var itemsRating$1 = PlRadar.handleDelta((itemsRating + 0.42) / 0.6);
    var scoutingRating = PlRadar.handleDelta(data.flexRating);
    tmp = React.createElement("div", {
          className: "pt-16"
        }, React.createElement("div", {
              className: "flex justify-between items-center pb-4"
            }, React.createElement("h4", {
                  className: "font-medium text-2xl text-secondary-11 font-montserrat font-semibold"
                }, "How did you do?"), React.createElement(Button, {
                  onClick: (function (param) {
                      return Curry._1(setShowPlayerRadarInfo, (function (param) {
                                    return true;
                                  }));
                    }),
                  variant: "outlined",
                  color: "primary",
                  size: "small",
                  children: "What are these grades?"
                })), React.createElement("div", {
              className: "flex pt-4 items-end justify-evenly"
            }, React.createElement(PlRadarChart.make, {
                  compositionsRating: compositionsRating,
                  econRating: econRating,
                  scoutingRating: scoutingRating,
                  executionRating: executionRating$1,
                  itemsRating: itemsRating$1,
                  small: false
                }), React.createElement("div", {
                  className: "pt-6 pr-3"
                }, React.createElement(PlPlacesDistribution.Inner.make, {
                      places: Belt_Array.concatMany(Belt_Array.mapWithIndex(data.placeDistribution, (function (idx, c) {
                                  return Belt_Array.make(c, idx + 1 | 0);
                                }))),
                      chartHeight: 160,
                      barArea: 21,
                      doubleUp: queueId === 1150 || queueId === 1160
                    }))));
  }
  return React.createElement(React.Fragment, undefined, tmp, showPlayerRadarInfo ? React.createElement(Modal, {
                    BackdropProps: {
                      className: CssJs.style([CssJs.important(CssJs.backgroundColor(CssJs.rgba(0, 0, 0, {
                                          NAME: "num",
                                          VAL: 0.6
                                        })))])
                    },
                    open: showPlayerRadarInfo,
                    onClose: (function (param) {
                        return Curry._1(setShowPlayerRadarInfo, (function (param) {
                                      return false;
                                    }));
                      }),
                    children: React.createElement("div", {
                          className: CssJs.style([
                                CssJs.outline(CssJs.px(0), CssJs.solid, CssJs.transparent),
                                CssJs.position(CssJs.absolute),
                                CssJs.left(CssJs.pct(50)),
                                CssJs.top(CssJs.pct(50)),
                                CssJs.transform(CssJs.translate(CssJs.pct(-50), CssJs.pct(-50)))
                              ])
                        }, React.createElement(Paper, {
                              children: React.createElement(PlayerRadarModalContents.make, {
                                    onClose: (function (param) {
                                        return Curry._1(setShowPlayerRadarInfo, (function (param) {
                                                      return false;
                                                    }));
                                      })
                                  })
                            }))
                  }) : null);
}

var RankedStats = {
  make: SetWrapped9Page$RankedStats
};

function SetWrapped9Page$Contents(Props) {
  var player = Props.player;
  var data = Props.data;
  var set = TftSet.use(undefined);
  React.useState(function () {
        return 2;
      });
  var match = React.useState(function () {
        
      });
  var setExpandedMatchId = match[1];
  var us = Belt_Array.map(data.top3stars, (function (param) {
          return [
                  Sd.unitTier(param[0]),
                  param[1]
                ];
        }));
  var tot1c = Belt_Array.reduce(Belt_Array.keep(us, (function (param) {
              return param[0] === 1;
            })), 0, (function (acc, param) {
          return acc + param[1] | 0;
        }));
  var tot2c = Belt_Array.reduce(Belt_Array.keep(us, (function (param) {
              return param[0] === 2;
            })), 0, (function (acc, param) {
          return acc + param[1] | 0;
        }));
  var tot3c = Belt_Array.reduce(Belt_Array.keep(us, (function (param) {
              return param[0] === 3;
            })), 0, (function (acc, param) {
          return acc + param[1] | 0;
        }));
  var tot4c = Belt_Array.reduce(Belt_Array.keep(us, (function (param) {
              return param[0] === 4;
            })), 0, (function (acc, param) {
          return acc + param[1] | 0;
        }));
  var tot5c = Belt_Array.reduce(Belt_Array.keep(us, (function (param) {
              return param[0] === 5;
            })), 0, (function (acc, param) {
          return acc + param[1] | 0;
        }));
  var itemStats = Belt_Array.map(Js_dict.entries(data.itemStats), (function (param) {
          return [
                  Data.encodeItemId(param[0]),
                  param[1]
                ];
        }));
  var tmp = {
    heroName: data.playerName,
    onClose: (function (param) {
        return Curry._1(setExpandedMatchId, (function (param) {
                      
                    }));
      })
  };
  var tmp$1 = match[0];
  if (tmp$1 !== undefined) {
    tmp.expandedMatchId = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", undefined, React.createElement(WrappedSection.make, {
                      children: null,
                      className: "p-5 mt-8"
                    }, React.createElement("div", {
                          className: "flex items-center pl-8"
                        }, React.createElement("div", {
                              className: "w-16 h-16 flex-shrink-0"
                            }, React.createElement(LlIcon.make, {
                                  companionId: data.mostPlayedCompanion,
                                  size: 64
                                })), React.createElement("div", {
                              className: "pl-3 text-2xl"
                            }, React.createElement("div", {
                                  className: "leading-none"
                                }, "Tactics.tools Set 9 wrapped for "), React.createElement("div", {
                                  className: "pl-1 pt-1 wrapped-num text-3xl font-montserrat font-semibold leading-none"
                                }, data.playerName))), React.createElement("div", {
                          className: "pt-8 flex w-full justify-evenly"
                        }, React.createElement("div", undefined, React.createElement("div", {
                                  className: "text-base pb-4"
                                }, "You took part in..."), React.createElement("div", {
                                  className: "text-lg leading-none grid items-center gap-3 gap-y-[14px] grid-cols-[76px,auto,1fr]"
                                }, React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totBattles
                                        })), React.createElement("div", undefined, "PvP Battles"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totGames
                                        })), React.createElement("div", undefined, "Games"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: Math.round(data.totGametime / 3600)
                                        })), React.createElement("div", undefined, "Hours of Play Time"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totTop4s
                                        })), React.createElement("div", undefined, "Top 4 Finishes"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totVictories
                                        })), React.createElement("div", undefined, "Emerged Victorious"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.riftHeraldFights
                                        })), React.createElement("div", undefined, "Rift Herald Fights"), React.createElement("div", undefined))), React.createElement("div", undefined, React.createElement("div", {
                                  className: "text pb-4"
                                }, "You have..."), React.createElement("div", {
                                  className: "text-lg leading-none grid items-center gap-3 gap-y-[14px] grid-cols-[76px,auto,1fr]"
                                }, React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totPlayerDamage
                                        })), React.createElement("div", undefined, "Player Damage"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totArmyValue
                                        }), ""), React.createElement("div", undefined, "Total Board Value"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totItemsUsed
                                        })), React.createElement("div", undefined, "Items Used"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totLevelups
                                        })), React.createElement("div", undefined, "Level Ups"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totSlain
                                        })), React.createElement("div", undefined, "Little Legends Slain"), React.createElement("div", undefined), React.createElement("div", {
                                      className: "text-primary-11 text-xll leading-none wrapped-num text-right"
                                    }, React.createElement(SetWrapped9Page$CountUp, {
                                          end: data.totDefeats
                                        })), React.createElement("div", undefined, "Times Been Slain"), React.createElement("div", undefined)))), React.createElement(SetWrapped9Page$RankedStats, {
                          region: player.region,
                          data: data,
                          queueId: player.queueId
                        }), player.queueId === 1100 && Js_dict.entries(data.patchStats).length !== 0 ? React.createElement(WrappedPatchStats.make, {
                            patchStats: data.patchStats,
                            queueId: player.queueId,
                            patches: patches
                          }) : null, React.createElement(WrappedPlaystyle.make, {
                          tierDistribution: data.tierDistribution,
                          starDistribution: data.starDistribution,
                          levelDistribution: data.levelDistribution
                        }), React.createElement(WrappedTimeStats.make, {
                          hourStats: data.hourStats,
                          dowStats: data.dowStats,
                          totGames: data.totGames,
                          region: player.region
                        }), React.createElement("div", {
                          className: "pt-16"
                        }, React.createElement(WrappedSectionHeader.make, {
                              title: "Favorite Champions"
                            }), React.createElement("div", {
                              className: "flex justify-between"
                            }, React.createElement("div", undefined, React.createElement("div", {
                                      className: "font-medium text-lg pb-3"
                                    }, "You had your favorite units..."), React.createElement("div", {
                                      className: "flex"
                                    }, Belt_Array.mapWithIndex(data.topUnits, (function (idx, param) {
                                            var u = param[0];
                                            return React.createElement("div", {
                                                        key: u,
                                                        className: "flex flex-col items-center" + (
                                                          idx === 0 ? "" : " pl-5"
                                                        )
                                                      }, React.createElement(WrapUnitImg.make, {
                                                            size: 76,
                                                            unitId: u
                                                          }), React.createElement(SetWrapped9Page$UnitStats, {
                                                            games: param[1],
                                                            top4: 0.54
                                                          }));
                                          })))), React.createElement("div", {
                                  className: "pl-8"
                                }, React.createElement("div", {
                                      className: "font-medium text-lg pb-3"
                                    }, "...and your favorite carries"), React.createElement("div", {
                                      className: "flex"
                                    }, Belt_Array.mapWithIndex(data.topCarries, (function (idx, param) {
                                            var u = param[0];
                                            return React.createElement("div", {
                                                        key: u,
                                                        className: "flex flex-col items-center" + (
                                                          idx === 0 ? "" : " pl-5"
                                                        )
                                                      }, React.createElement(WrapUnitImg.make, {
                                                            size: 76,
                                                            unitId: u
                                                          }), React.createElement(SetWrapped9Page$UnitStats, {
                                                            games: param[1],
                                                            top4: 0.54
                                                          }));
                                          })))))), (Belt_Array.reduce(data.star4costs, 0, (function (acc, param) {
                              return acc + param[1] | 0;
                            })), React.createElement("div", {
                            className: "pt-8"
                          }, React.createElement("div", {
                                className: "flex justify-between"
                              }, React.createElement("div", {
                                    className: "w-full"
                                  }, React.createElement("div", {
                                        className: "font-medium text-lg pb-4"
                                      }, "You have 3-starred a total of ", React.createElement("span", {
                                            className: "wrapped-num text-primary-11"
                                          }, String(data.tot3stars)), " units (", React.createElement("span", {
                                            className: CssJs.merge([
                                                  "wrapped-num px-[1px]",
                                                  CssJs.style([CssJs.color(CssJs.hex(Colors.common))])
                                                ])
                                          }, String(tot1c)), "/", React.createElement("span", {
                                            className: CssJs.merge([
                                                  "wrapped-num px-[1px]",
                                                  CssJs.style([CssJs.color(CssJs.hex(Colors.uncommon))])
                                                ])
                                          }, String(tot2c)), "/", React.createElement("span", {
                                            className: CssJs.merge([
                                                  "wrapped-num px-[1px]",
                                                  CssJs.style([CssJs.color(CssJs.hex(Colors.rare))])
                                                ])
                                          }, String(tot3c)), "/", React.createElement("span", {
                                            className: CssJs.merge([
                                                  "wrapped-num px-[1px]",
                                                  CssJs.style([CssJs.color(CssJs.hex(Colors.epic))])
                                                ])
                                          }, String(tot4c)), "/", React.createElement("span", {
                                            className: CssJs.merge([
                                                  "wrapped-num px-[1px]",
                                                  CssJs.style([CssJs.color(CssJs.hex(Colors.legendary))])
                                                ])
                                          }, String(tot5c)), " by cost)"), React.createElement("div", {
                                        className: CssJs.merge([
                                              "grid justify-between",
                                              CssJs.style([
                                                    CssJs.gridTemplateColumns([
                                                          CssJs.auto,
                                                          CssJs.auto
                                                        ]),
                                                    CssJs.gridRowGap(CssJs.px(24))
                                                  ])
                                            ])
                                      }, React.createElement("div", {
                                            className: "flex"
                                          }, Belt_Array.mapWithIndex(Belt_Array.slice(Belt_Array.keep(data.top3stars, (function (param) {
                                                          return Sd.unitTier(param[0]) === 1;
                                                        })), 0, 3), (function (idx, param) {
                                                  var u = param[0];
                                                  return React.createElement("div", {
                                                              key: u,
                                                              className: "flex flex-col items-center" + (
                                                                idx === 0 ? "" : " pl-5"
                                                              )
                                                            }, React.createElement(WrapUnitImg.make, {
                                                                  starred: true,
                                                                  size: 76,
                                                                  unitId: u
                                                                }), React.createElement(SetWrapped9Page$UnitStats, {
                                                                  games: param[1],
                                                                  top4: 0.54
                                                                }));
                                                }))), React.createElement("div", {
                                            className: "flex"
                                          }, Belt_Array.mapWithIndex(Belt_Array.slice(Belt_Array.keep(data.top3stars, (function (param) {
                                                          return Sd.unitTier(param[0]) === 2;
                                                        })), 0, 3), (function (idx, param) {
                                                  var u = param[0];
                                                  return React.createElement("div", {
                                                              key: u,
                                                              className: "flex flex-col items-center" + (
                                                                idx === 0 ? "" : " pl-5"
                                                              )
                                                            }, React.createElement(WrapUnitImg.make, {
                                                                  starred: true,
                                                                  size: 76,
                                                                  unitId: u
                                                                }), React.createElement(SetWrapped9Page$UnitStats, {
                                                                  games: param[1],
                                                                  top4: 0.54
                                                                }));
                                                }))), React.createElement("div", {
                                            className: "flex"
                                          }, Belt_Array.mapWithIndex(Belt_Array.slice(Belt_Array.keep(data.top3stars, (function (param) {
                                                          return Sd.unitTier(param[0]) === 3;
                                                        })), 0, 3), (function (idx, param) {
                                                  var u = param[0];
                                                  return React.createElement("div", {
                                                              key: u,
                                                              className: "flex flex-col items-center" + (
                                                                idx === 0 ? "" : " pl-5"
                                                              )
                                                            }, React.createElement(WrapUnitImg.make, {
                                                                  starred: true,
                                                                  size: 76,
                                                                  unitId: u
                                                                }), React.createElement(SetWrapped9Page$UnitStats, {
                                                                  games: param[1],
                                                                  top4: 0.54
                                                                }));
                                                }))), React.createElement("div", {
                                            className: "flex"
                                          }, Belt_Array.mapWithIndex(Belt_Array.slice(Belt_Array.keep(data.top3stars, (function (param) {
                                                          return Sd.unitTier(param[0]) === 4;
                                                        })), 0, 3), (function (idx, param) {
                                                  var u = param[0];
                                                  return React.createElement("div", {
                                                              key: u,
                                                              className: "flex flex-col items-center" + (
                                                                idx === 0 ? "" : " pl-5"
                                                              )
                                                            }, React.createElement(WrapUnitImg.make, {
                                                                  starred: true,
                                                                  size: 76,
                                                                  unitId: u
                                                                }), React.createElement(SetWrapped9Page$UnitStats, {
                                                                  games: param[1],
                                                                  top4: 0.54
                                                                }));
                                                })))))), data.star5costs.length !== 0 ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                                      className: "font-medium pb-3 pt-4"
                                    }, "You have even 3-starred some 5 cost units!", React.createElement("br", undefined), "Click on the unit to see lobby for the match."), React.createElement("div", {
                                      className: CssJs.style([
                                            CssJs.display(CssJs.grid),
                                            CssJs.gridGap(CssJs.px(20)),
                                            CssJs.gridRowGap(CssJs.px(20)),
                                            CssJs.gridTemplateColumns([{
                                                    NAME: "repeat",
                                                    VAL: [
                                                      {
                                                        NAME: "num",
                                                        VAL: 6
                                                      },
                                                      CssJs.px(76)
                                                    ]
                                                  }])
                                          ])
                                    }, Belt_Array.map(data.star5costs, (function (d) {
                                            var unitId = d[1];
                                            var matchId = d[0];
                                            return React.createElement("div", {
                                                        key: matchId + unitId,
                                                        className: "cursor-pointer",
                                                        onClick: (function (param) {
                                                            return Curry._1(setExpandedMatchId, (function (param) {
                                                                          return matchId;
                                                                        }));
                                                          })
                                                      }, React.createElement(WrapUnitImg.make, {
                                                            size: 76,
                                                            unitId: unitId
                                                          }));
                                          })))) : null)), React.createElement("div", {
                          className: "pt-16"
                        }, React.createElement(WrappedSectionHeader.make, {
                              title: "Favorite Items"
                            }), React.createElement("div", {
                              className: "w-full"
                            }, React.createElement("div", {
                                  className: "pb-2 text-lg flex items-center"
                                }, React.createElement("div", {
                                      className: "wrapped-num text-xl text-primary-11 pr-[6px]"
                                    }, String(data.totItemsCount)), " items equipped"), React.createElement("div", {
                                  className: "flex justify-between w-full"
                                }, Belt_Array.mapWithIndex(Belt_Array.slice(Belt_Array.keep(Belt_SortArray.stableSortBy(itemStats, (function (param, param$1) {
                                                    return Caml_obj.caml_compare(param$1[1], param[1]);
                                                  })), (function (param) {
                                                return Belt_Option.isSome(Js_dict.get(Data9.items, param[0]));
                                              })), 0, 8), (function (idx, param) {
                                        var match = param[1];
                                        var itemId = param[0];
                                        return React.createElement("div", {
                                                    key: itemId,
                                                    className: "w-[60px] flex flex-col items-center"
                                                  }, React.createElement("div", {
                                                        className: "flex flex-col items-center"
                                                      }, React.createElement("div", {
                                                            className: "rounded overflow-hidden"
                                                          }, React.createElement(ItemImage.make, {
                                                                itemId: itemId,
                                                                size: 58
                                                              })), React.createElement("div", {
                                                            className: "text-xs text-center pt-2 whitespace-nowrap"
                                                          }, String(match[0]) + " games")), React.createElement("div", {
                                                        className: "pt-4 flex flex-col items-center"
                                                      }, React.createElement(UnitImageExtended.make, {
                                                            size: 44,
                                                            unitId: match[1],
                                                            itemSize: 24,
                                                            itemSizeCompact: 24,
                                                            items: [itemId]
                                                          }), React.createElement("div", {
                                                            className: "text-xs pt-4"
                                                          }, String(match[2]) + " games")));
                                      }))))), React.createElement("div", {
                          className: "pt-16"
                        }, React.createElement(WrappedSectionHeader.make, {
                              title: "Favorite Traits"
                            }), React.createElement("div", {
                              className: "flex justify-between"
                            }, Belt_Array.map(Belt_Array.slice(Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_Array.map(Js_dict.entries(data.traitStats), (function (param) {
                                                    var split = param[0].split("__");
                                                    var trait = Trait9.fromApiName(Belt_Array.getExn(split, 0));
                                                    var rank = Belt_Option.getExn(Belt_Int.fromString(Belt_Array.getExn(split, 1)));
                                                    return [
                                                            trait,
                                                            rank,
                                                            param[1]
                                                          ];
                                                  })), (function (param) {
                                                var rank = param[1];
                                                var trait = param[0];
                                                if (Sd.traitRankUnitCount(Trait9.toApiName(trait), rank, set) > 1) {
                                                  return Sd.traitStyle(Trait9.toApiName(trait), rank, set) > 1;
                                                } else {
                                                  return false;
                                                }
                                              })), (function (param, param$1) {
                                            return Caml.caml_int_compare(param$1[2], param[2]);
                                          })), 0, 8), (function (param) {
                                    var count = param[2];
                                    var rank = param[1];
                                    var trait = param[0];
                                    return React.createElement("div", {
                                                key: Trait9.toApiName(trait) + String(count),
                                                className: "w-[60px] flex flex-col items-center"
                                              }, React.createElement(TraitTooltip.make, {
                                                    trait: Trait9.toApiName(trait),
                                                    rank: rank,
                                                    children: React.createElement(TraitImage.PlainIcon2.make, {
                                                          traitId: Trait9.toApiName(trait),
                                                          rank: rank,
                                                          size: 48
                                                        })
                                                  }), React.createElement("div", {
                                                    className: "pt-1 text-xs"
                                                  }, String(count) + " games"));
                                  })))), React.createElement(WrappedChaseTraits.make, {
                          allChaseTraits: allChaseTraits,
                          topChaseTraits: data.topChaseTraits,
                          queueId: player.queueId
                        }), React.createElement("div", {
                          className: "pt-16"
                        }, React.createElement(WrappedSectionHeader.make, {
                              title: "Favorite Augments"
                            }), React.createElement(WrappedAugments.make, {
                              topT1Augments: data.topT1Augments,
                              topT2Augments: data.topT2Augments,
                              topT3Augments: data.topT3Augments,
                              goldenEggGames: data.goldenEggGames,
                              triplePrismGames: data.triplePrismGames
                            })), React.createElement(SetWrapped9Page$TopComps, {
                          queueId: player.queueId,
                          topCompositions: data.topCompositions
                        }), React.createElement(WrappedRivalStats.make, {
                          uniqueRivals: data.uniqueRivals,
                          rivalStats: data.rivalStats
                        }), React.createElement(WrappedCompanionStats.make, {
                          uniqueCompanions: data.uniqueCompanions,
                          companionStats: data.companionStats
                        }), React.createElement(WrappedRivalCompanionStats.make, {
                          topRivalCompanions: data.topRivalCompanions,
                          botRivalCompanions: data.botRivalCompanions
                        }), React.createElement(SetWrapped9Page$HighlightMatches, {
                          data: data,
                          setExpandedMatchId: setExpandedMatchId
                        })), React.createElement(WrappedUnitBubbles.make, {
                      unitStats: data.unitStats,
                      unitDistribution: data.unitDistribution,
                      totGames: data.totGames,
                      topCompanions: data.topCompanions
                    }), React.createElement(PlExpandedMatch.make, tmp)));
}

var make = React.memo(SetWrapped9Page$Contents);

var Contents = {
  make: make
};

function SetWrapped9Page$Inner(Props) {
  var data = Props.data;
  var player = Props.player;
  var error = Props.error;
  var loading = Props.loading;
  React.useEffect((function () {
          console.log("DD", data);
          
        }), [data]);
  var tmp;
  var exit = 0;
  if (Belt_Option.isSome(error)) {
    console.log([
          player,
          data
        ]);
    tmp = React.createElement(WrappedSection.make, {
          children: null,
          className: "mt-8"
        }, React.createElement("div", undefined, "Unknown error has occured. Please try again in a minute."), React.createElement("div", {
              className: "pt-1"
            }, "If this keeps repeating please report this to", React.createElement("a", {
                  className: "text-primary-11 font-medium",
                  href: "https://discord.gg/K4Z6shucH8",
                  target: "_blank"
                }, " Discord")));
  } else if (data !== undefined && data.TAG !== /* Ok */0) {
    var match = data._0;
    tmp = match !== 404 ? (
        match !== 500 ? null : React.createElement(WrappedSection.make, {
                children: null,
                className: "mt-8"
              }, React.createElement("div", undefined, "Unknown error has occured. Please try again in a minute."), React.createElement("div", {
                    className: "pt-1"
                  }, "If this keeps repeating please report this to", React.createElement("a", {
                        className: "text-primary-11 font-medium",
                        href: "https://discord.gg/K4Z6shucH8",
                        target: "_blank"
                      }, " Discord")))
      ) : React.createElement(WrappedSection.make, {
            children: "No TFT data found for this combination of region, summoner name and queue type.",
            className: "mt-8"
          });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    if (player !== undefined && data !== undefined) {
      var data$1 = data._0;
      tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
                className: "flex justify-center pt-12"
              }, React.createElement(WrappedShareButton.make, {
                    player: player
                  }), React.createElement("div", {
                    className: "pl-8"
                  }, React.createElement(WrappedScreenshotButton.make, {
                        player: player
                      }))), React.createElement("div", {
                className: "relative"
              }, React.createElement("div", {
                    className: CssJs.merge([CssJs.style([
                                CssJs.zIndex(-1),
                                CssJs.position(CssJs.absolute),
                                T.md_([
                                      CssJs.top(CssJs.px(-24)),
                                      CssJs.left(CssJs.px(-24)),
                                      CssJs.right(CssJs.px(-24)),
                                      CssJs.bottom(CssJs.px(-16))
                                    ])
                              ])]),
                    id: "wrapped-ss-area"
                  }), React.createElement(make, {
                    player: player,
                    data: data$1,
                    key: Region.toApiName(player.region) + data$1.playerName
                  })), React.createElement("div", {
                className: "flex items-center justify-center my-6"
              }, React.createElement("div", {
                    className: "mr-3 text-lg"
                  }, "Like the content?!"), React.createElement("a", {
                    href: "https://patreon.com/tactics_tools",
                    target: "_blank"
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            
                          }),
                        variant: "contained",
                        color: "secondary",
                        children: null
                      }, React.createElement("img", {
                            height: "20",
                            src: "https://ap.tft.tools/img/general/patreon.png?w=20",
                            width: "20"
                          }), React.createElement("span", {
                            className: "ml-2"
                          }, "Join the Patreon!")))), React.createElement("div", {
                className: "flex justify-center pt-12"
              }, React.createElement(WrappedShareButton.make, {
                    player: player
                  }), React.createElement("div", {
                    className: "pl-8"
                  }, React.createElement(WrappedScreenshotButton.make, {
                        player: player
                      }))));
    } else {
      tmp = null;
    }
  }
  var tmp$1 = {
    loading: loading,
    children: tmp
  };
  if (player !== undefined) {
    tmp$1.player = Caml_option.valFromOption(player);
  }
  return React.createElement(WrappedLayout.make, tmp$1);
}

var Inner = {
  make: SetWrapped9Page$Inner
};

function SetWrapped9Page(Props) {
  var match = React.useState(function () {
        return false;
      });
  var setLoading = match[1];
  var match$1 = React.useState(function () {
        
      });
  var setData = match$1[1];
  var data = match$1[0];
  var router = Router.useRouter();
  var player = React.useMemo((function () {
          var route = Route.fromAsPath(router.asPath);
          if (typeof route === "number" || route.TAG !== /* SetWrapped */4) {
            return ;
          } else {
            return route._1;
          }
        }), [router.asPath]);
  React.useEffect((function () {
          var cancelled = {
            contents: false
          };
          if (player !== undefined) {
            Curry._1(setLoading, (function (param) {
                    return true;
                  }));
            Curry._1(setData, (function (param) {
                    
                  }));
            $$Promise.consume2(PlApi.getReviewData9(player), (function (data) {
                    if (!cancelled.contents) {
                      Curry._1(setData, (function (param) {
                              return [
                                      player,
                                      data
                                    ];
                            }));
                      return Curry._1(setLoading, (function (param) {
                                    return false;
                                  }));
                    }
                    
                  }), (function (err) {
                    if (!cancelled.contents) {
                      Curry._1(setData, (function (param) {
                              return [
                                      player,
                                      {
                                        TAG: /* Error */1,
                                        _0: 500
                                      }
                                    ];
                            }));
                      return Curry._1(setLoading, (function (param) {
                                    return false;
                                  }));
                    }
                    
                  }));
          }
          return (function (param) {
                    Curry._1(setLoading, (function (param) {
                            return false;
                          }));
                    cancelled.contents = true;
                    
                  });
        }), [router.asPath]);
  var data$1;
  if (data !== undefined) {
    var data$2 = data[1];
    data$1 = player !== undefined && !Caml_obj.caml_equal(data[0], player) ? undefined : data$2;
  } else {
    data$1 = undefined;
  }
  var tmp = {
    loading: match[0]
  };
  if (data$1 !== undefined) {
    tmp.data = Caml_option.valFromOption(data$1);
  }
  if (player !== undefined) {
    tmp.player = Caml_option.valFromOption(player);
  }
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set9 */0, React.createElement(SetWrapped9Page$Inner, tmp), undefined));
}

var make$1 = SetWrapped9Page;

export {
  UnitStats ,
  CountUp ,
  patches ,
  allChaseTraits ,
  TopComps ,
  HighlightMatches ,
  Stat ,
  WrappedRadar ,
  RankedStats ,
  Contents ,
  Inner ,
  make$1 as make,
  
}
/* make Not a pure module */
